import {
  BookOpen,
  ClipboardCheck,
  Code2,
  GraduationCap,
  LayoutDashboard,
  MessagesSquare,
  MessageSquareText,
  Package,
  Settings,
  ShieldCheck,
  SlidersHorizontal,
  UserRound,
  Webhook,
  type LucideIcon,
} from 'lucide-react'

import type { ProjectSection } from '@/features/projects/project-routes'

export interface ProjectNavItem {
  section: ProjectSection
  label: string
  subtitle: string
  icon: LucideIcon
}

export const PROJECT_NAV_ITEMS: ProjectNavItem[] = [
  {
    section: 'overview',
    label: 'Обзор',
    subtitle: 'О проекте и статистика',
    icon: LayoutDashboard,
  },
  {
    section: 'prompts',
    label: 'Промпты',
    subtitle: 'Создавайте и управляйте промптами, которые используют ваши AI-ассистенты.',
    icon: MessageSquareText,
  },
  {
    section: 'knowledge',
    label: 'База знаний',
    subtitle: 'Документы, правила и источники для ответов ассистента.',
    icon: BookOpen,
  },
  {
    section: 'products',
    label: 'Товары',
    subtitle: 'Каталог товаров и импорт файлов.',
    icon: Package,
  },
  {
    section: 'conversations',
    label: 'Диалоги',
    subtitle: 'Диалоги с клиентами.',
    icon: MessagesSquare,
  },
  {
    section: 'leads',
    label: 'Лиды',
    subtitle: 'Контакты, собранные из диалогов.',
    icon: UserRound,
  },
  {
    section: 'widget',
    label: 'Виджет',
    subtitle: 'Настройки и код для встраивания виджета.',
    icon: Code2,
  },
  {
    section: 'fine-tuning',
    label: 'Тонкие настройки',
    subtitle: 'Профили менеджеров и поведение виджета в диалоге.',
    icon: SlidersHorizontal,
  },
  {
    section: 'training',
    label: 'Автообучение',
    subtitle: 'Предложения для базы знаний на основе диалогов.',
    icon: GraduationCap,
  },
  {
    section: 'integrations',
    label: 'Интеграции',
    subtitle: 'Вебхук новых лидов и его проверка.',
    icon: Webhook,
  },
  { section: 'settings', label: 'Настройка', subtitle: 'Конфигурация проекта.', icon: Settings },
  {
    section: 'policy',
    label: 'Политика',
    subtitle: 'Политика согласия и приватность.',
    icon: ShieldCheck,
  },
  {
    section: 'audit',
    label: 'Проверка проекта',
    subtitle: 'ИИ-аудит промпта и базы',
    icon: ClipboardCheck,
  },
]

export interface KnowledgeTabItem {
  section: ProjectSection
  label: string
  subtitle: string
}

export const KNOWLEDGE_SECTION_TITLE = 'База знаний'
export const KNOWLEDGE_SECTION_ICON = BookOpen

export const KNOWLEDGE_TABS: KnowledgeTabItem[] = [
  {
    section: 'knowledge',
    label: 'Знания',
    subtitle: 'Документы, правила и источники для ответов ассистента.',
  },
  {
    section: 'chunk-links',
    label: 'Связи',
    subtitle: 'Семантические связи между фрагментами базы знаний.',
  },
]

export function isKnowledgeTabSection(section: string): boolean {
  return KNOWLEDGE_TABS.some((tab) => tab.section === section)
}

export function findKnowledgeTab(section: string): KnowledgeTabItem | undefined {
  return KNOWLEDGE_TABS.find((tab) => tab.section === section)
}
